/**
 * A function that logs a click event to Google Analytics.
 * @param {HTMLElement} target The DOM element that triggered the event.
 * @param {string} eventName A string in the format "event_name--event_specifics" where "event_name is the type of event, such as "map_click" or "dropdown_select" and "event_specifics" refers to the selected option, region, or specific function.
 * @returns {void}
 */
export function logClickToGA(target, eventName) {
  const eventData = {
    dataviz_title: document.title,
    dataviz_target: target,
    dataviz_detail: eventName
  };
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "dataviz_click", eventData);
}
